import React, { useState } from "react";
import styled from "styled-components";

interface Props {
  value: string;
  isActive?: boolean;
}

const Styled = styled.div<Props>`
  padding: 0.4em 0.55em;
  border-bottom: solid 2px #ddd;
  display: inline-block;
  margin-bottom: -2px;
  color: #006699;
  cursor: pointer;

  ${(props) => {
    if (props.isActive) {
      return `
      color: #000;
      border-bottom: solid 2px #d41818;
      font-weight: 500;
      `;
    }
  }}
`;

const TabItem: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return <Styled {...props}>{props.children}</Styled>;
};

export default TabItem;
